import { Component, Injectable, inject } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { MessageBoxCustomButton, MessageDialogComponent } from '../../components/message-dialog/message-dialog.component';
import { DialogAnimationService } from '../../services/dialog-animation.service';
import { SaveSheetService } from '../../services/save-sheet.service';
import { MatDialogRef } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';

export const saveSheetGuard: CanDeactivateFn<Component> = () => inject(SaveSheetGuard).canDeactivate();

@Injectable({
  providedIn: 'root',
})
export class SaveSheetGuard  {
  constructor(
    private saveSheet: SaveSheetService,
    private translate: TranslateService,
    private dialog: DialogAnimationService,
    ) {}

  public canDeactivate(): Observable<boolean> | boolean {
    if (this.saveSheet.openStatus$.value) {
      return this.displayNotAppliedWarning();
    }

    return true;
  }

  private displayNotAppliedWarning(): Observable<boolean> {
    const headerText: string = this.translate.instant('Header.NotAppliedChangesHeader');
    const messageText: string = this.translate.instant('Header.NotAppliedChangesMessage')

    const dialogRef: MatDialogRef<MessageDialogComponent> = this.dialog.open(MessageDialogComponent, {
      panelClass: 'messagebox-dialog',
      autoFocus: false,
      data: { headerInfo: headerText, message: messageText, buttons: MessageBoxCustomButton.YesNo }
    });

    return dialogRef.afterClosed();
  }
}
